// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-unused-vars, prettier/prettier */
import * as Types from './generated/types';

import { gql } from '@apollo/client';
export type MediaFieldsFragment = { __typename?: 'Media', url: string, description?: string | null, mime_type?: string | null, file_name?: string | null };

export const MediaFieldsFragmentDoc = gql`
    fragment MediaFields on Media {
  url
  description
  mime_type
  file_name
}
    `;